var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abstretch bg-canvas p-5",staticStyle:{"overflow":"auto"}},[(_vm.data)?_c('display-json',{attrs:{"data":_vm.data,"pretty":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }